import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import React from 'react';

import css from './TemplateMainInfoSection.module.css';
import { CustomProjectEntity } from '@entities/CustomProject/Types';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';

interface TemplateMainInfoSectionProps {
    project: CustomProjectEntity;
}

export const TemplateMainInfoSection: React.FC<
    TemplateMainInfoSectionProps
> = ({ project }) => {
    const [_isDesktop, _isTablet, isMobile] = useMediaType();
    const template = project.templates?.[0];

    const descriptionText = template?.shortDescription || 'No description';

    return isMobile ? (
        <div className={css.container}>
            <div className={css.progressAndType}>
                <div className={css.progressBarWrapper}>
                    <CircularProgressbar
                        value={project.progress ?? 0}
                        text={`${project.progress ?? 0}%`}
                        strokeWidth={15}
                        classes={{
                            root: '',
                            trail: '',
                            path: '',
                            text: css.circleText,
                            background: '',
                        }}
                        styles={buildStyles({
                            pathColor: '#0E7B51',
                            trailColor: '#D9D9D9',
                            textSize: '20px',
                            textColor: '#5F6368',
                            pathTransitionDuration: 0.5,
                            strokeLinecap: 'round',
                        })}
                    />
                </div>
                <div className={css.typeContainer}>
                    <div className={css.type}>Type:</div>
                    <div className={css.title}>{template?.title}</div>
                </div>
            </div>
            <div className={css.descriptionContainer}>
                <h2 className={css.description}>Description:</h2>
                <div className={css.descriptionText}>{descriptionText}</div>
            </div>
        </div>
    ) : (
        <div className={css.container}>
            <div className={css.typeContainer}>
                <div className={css.type}>Type:</div>
                <div className={css.title}>{template?.title}</div>
            </div>
            <div className={css.descriptionContainer}>
                <div className={css.description}>Description:</div>
                <div className={css.descriptionText}>{descriptionText}</div>
            </div>
            <div className={css.progressBarWrapper}>
                <CircularProgressbar
                    value={project.progress ?? 0}
                    text={`${project.progress ?? 0}%`}
                    strokeWidth={15}
                    classes={{
                        root: '',
                        trail: '',
                        path: '',
                        text: css.circleText,
                        background: '',
                    }}
                    styles={buildStyles({
                        pathColor: '#0E7B51',
                        trailColor: '#D9D9D9',
                        textSize: '20px',
                        textColor: '#5F6368',
                        pathTransitionDuration: 0.5,
                        strokeLinecap: 'round',
                    })}
                />
            </div>
        </div>
    );
};
